document.addEventListener('DOMContentLoaded', function () {
  const texts = document.querySelectorAll('.text-inner__container .text-feature__item');
  const images = document.querySelectorAll('.images-inner__container .image-feature__item');
  const progressBar = document.querySelector('.scroll-feature-line');
  const textContainer = document.querySelector('.text-inner__container');
  const lastTextItem = texts[texts.length - 1]; // The last text feature item

  const observerOptions = {
    root: null,
    threshold: 1,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const textItem = entry.target;
      const activeTextId = textItem.getAttribute('data-text-id');

      if (entry.isIntersecting) {
        textItem.classList.add('active');

        images.forEach(image => {
          image.style.display = 'none';
        });

        images.forEach(image => {
          const imageId = image.getAttribute('data-image-id');
          if (imageId === activeTextId) {
            image.style.display = 'block';
          }
        });
      } else if (entry.boundingClientRect.top > 0) {
        textItem.classList.remove('active');

        const matchingImage = Array.from(images).find(image => image.getAttribute('data-image-id') === activeTextId);
        if (matchingImage) {
          matchingImage.style.display = 'none';
        }
      }
    });

    const firstTextItem = texts[0];
    const firstImage = images[0];
    const activeText = Array.from(texts).find(text => text.classList.contains('active'));

    if (!activeText && firstImage) {
      images.forEach(image => image.style.display = 'none');
      firstImage.style.display = 'block';
    }
  }, observerOptions);

  texts.forEach(text => observer.observe(text));

  const firstTextItem = texts[0];
  const firstImage = images[0];

  images.forEach(image => image.style.display = 'none');
  if (firstImage) {
    firstImage.style.display = 'block';
  }

  if (firstTextItem) {
    firstTextItem.classList.add('active');
  }

  const textContainerTop = textContainer.getBoundingClientRect().top;
  const textContainerBottom = textContainer.getBoundingClientRect().bottom;
  const viewportHeight = window.innerHeight;

  let progressHeight = 0;

  if (textContainerTop < viewportHeight * 0.5 && textContainerBottom > 0) {
    const visibleHeight = Math.min(
      textContainer.offsetHeight,
      viewportHeight * 0.5 - textContainerTop
    );

    progressHeight = Math.max(0, visibleHeight);
  }

  const lastTextItemHeight = lastTextItem ? lastTextItem.offsetHeight : 0;
  const maxHeight = textContainer.offsetHeight;
  const adjustedHeight = Math.min(progressHeight, maxHeight - lastTextItemHeight);

  const finalHeight = Math.max(0, adjustedHeight - 20);

  progressBar.style.height = `${finalHeight}px`;

  window.addEventListener('scroll', () => {
    const textContainerTop = textContainer.getBoundingClientRect().top;
    const textContainerBottom = textContainer.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight;

    let progressHeight = 0;

    if (textContainerTop < viewportHeight * 0.5 && textContainerBottom > 0) {
      const visibleHeight = Math.min(
        textContainer.offsetHeight,
        viewportHeight * 0.5 - textContainerTop
      );

      progressHeight = Math.max(0, visibleHeight);
    }

    const lastTextItemHeight = lastTextItem ? lastTextItem.offsetHeight : 0;
    const maxHeight = textContainer.offsetHeight;
    const adjustedHeight = Math.min(progressHeight, maxHeight - lastTextItemHeight);

    const finalHeight = Math.max(0, adjustedHeight - 20);

    progressBar.style.height = `${finalHeight}px`;
  });
});